/**
 * Generate a stable unique-ish id with a short prefix. Used for choices,
 * variants, feedback variants, and nodes. Not cryptographically random —
 * just collision-resistant enough that two ids generated back-to-back in the
 * same authoring session won't clash.
 */
export function newId(prefix = 'n') {
    return prefix + '_' + Math.random().toString(36).slice(2, 9);
}
//# sourceMappingURL=ids.js.map